import React from 'react';
import { Switch, TextField, InputAdornment } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import styles from './LeadsToolbar.module.css';

const formatDate = (date) => {
  if (!date) return '';
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

/** Resumo do período e filtros locais do kanban (inválidos e telefone). */
function LeadsToolbar({ total, startDate, endDate, viewInvalid, onViewInvalidChange, phoneSearch, onPhoneSearchChange }) {
  const period = startDate && endDate ? `${formatDate(startDate)} a ${formatDate(endDate)}` : '';

  return (
    <div className={styles.toolbar}>
      <div className={styles.summary}>
        <span className={styles.summaryIcon}><InsightsOutlinedIcon style={{ fontSize: 20 }} /></span>
        <div className={styles.summaryText}>
          <span className={styles.summaryValue}>
            {total === 1 ? '1 lead' : `${total} leads`}
            <span className={styles.summaryLabel}> no período</span>
          </span>
          {period && <span className={styles.summaryPeriod}>{period}</span>}
        </div>
      </div>

      <div className={styles.filters}>
        <label className={styles.toggle}>
          <Switch size="small" checked={viewInvalid} onChange={(e) => onViewInvalidChange(e.target.checked)} />
          <span>Mostrar inválidos</span>
        </label>
        <TextField
          size="small"
          placeholder="Buscar por telefone"
          variant="outlined"
          value={phoneSearch}
          onChange={(e) => onPhoneSearchChange(e.target.value)}
          className={styles.search}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon style={{ fontSize: 19, color: '#94A3B8' }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
}

export default LeadsToolbar;
